import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import moment from 'moment';

import { GET_MEETINGS } from '../graphql';

import {
  Table,
  Text,
  Link,
  Loader,
} from './styles';

function CustomTable({ testSessionId, handleProcess, handleDownload }) {
  const { data, loading } = useQuery(GET_MEETINGS, {
    variables: {
      testSessionId,
    },
  });

  if (loading) {
    return <Loader size="medium" data-loader="custom-table-loader" />;
  }

  const renderSelected = (value) => {
    if (value) { return 'Selected'; }
    return '';
  };

  const renderStartedAt = (value) => moment(value).tz(moment.tz.guess()).format('hh:mm a z');

  const renderDuration = (value) => moment.utc(value).format('HH:mm:ss');

  return (
    <Table basic="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            <Text.Bold>Meeting ID</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Start time</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Length</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold />
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold />
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold />
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {data.meetings.map((meeting) => {
          const {
            id, startedAt, duration, selected, videoUrl,
          } = meeting;

          return (
            <Table.Row key={id}>
              <Table.Cell>
                <Text>{data.testSession.meetingId}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{renderStartedAt(startedAt)}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{renderDuration(duration)}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{renderSelected(selected)}</Text>
              </Table.Cell>

              <Table.Cell>
                <Link onClick={() => handleDownload(videoUrl)}>Download</Link>
              </Table.Cell>

              <Table.Cell>
                {!selected && <Link onClick={() => handleProcess(id)}>Select and Process</Link>}
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
}

CustomTable.propTypes = {
  handleProcess: PropTypes.func.isRequired,
  handleDownload: PropTypes.func.isRequired,
  testSessionId: PropTypes.string.isRequired,
};

export default CustomTable;
